// extracted by mini-css-extract-plugin
module.exports = {"buttonSpacer":"_2V3M1N7vJoHi6m09VM9464"};